
import React, { useEffect, useState } from 'react';
import { FaMapMarker } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import SlicingTextList from '../../../../components/SlicingTextList';
import { urlWebsite } from '../../../../config';
import { useConfiguration } from '../../../../hooks/Configuration';
import { useLanguage } from '../../../../hooks/Language';
import {

    Capa, Container,



} from '../Themes/SinglePageTheme/styles';

const HomeApplication = () => {
    const { configuration, projectHash } = useConfiguration();
    const { translate } = useLanguage();

    const [theme, setTheme] = useState({
        titleColor: configuration?.current_event_id_response?.theme?.title_color || '#fff',
        textColor: configuration?.current_event_id_response?.theme?.text_color || '#fff',
        buttonColor: configuration?.current_event_id_response?.theme?.button_color || 'rgb(78, 27, 129)',
        buttonBackground: configuration?.current_event_id_response?.theme?.button_background || '#3FB8EB',
    })


    useEffect(() => {
        setTheme({
            titleColor: configuration?.current_event_id_response?.theme?.title_color || '#fff',
            textColor: configuration?.current_event_id_response?.theme?.text_color || '#fff',
            buttonColor: configuration?.current_event_id_response?.theme?.button_color || 'rgb(78, 27, 129)',
            buttonBackground: configuration?.current_event_id_response?.theme?.button_background || '#3FB8EB',
        })
    }, [configuration])


    return <Container>
        <Capa className='element'>

            <div className='header'>
                <div className='column imageContent' style={{ width: '100%', maxWidth: '800px', background: '#fff', }}>
                    <div className='row-start ' style={{ background: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {configuration?.logo ? <img className=' fadeIn ' style={{ width: '400px', maxWidth: '45%' }} src={'/apoio/logo-capa.png'} /> : <></>}
                        <img src='/apoio/textocapa.png' style={{ width: '400px', maxWidth: '45%' }} />
                    </div>
                    <div className='capa-content' style={{ background: '#fff', }}>

                        <h2 style={{ color: 'rgb(10, 79, 75)', fontSize: '16px', maxWidth: '800px', textAlign: 'left' }} ><strong style={{ color: 'rgb(10, 79, 75)' }} >07, 08 e 09 de maio de 2025 <br />Barra Shopping Sul - Porto Alegre / RS</strong></h2>




                        <div className='buttonsDiv' style={{ width: '100%', margin: '25px auto', marginBottom: '0px', gap: '10px' }}>
                            {configuration?.active_pages && configuration?.active_pages?.map(button => {
                                return button?.button !== 'yes' ? <></> : button?.type === 'external' ? <a href={button.url} target="_BLANK" ><button className='highlightButton shadow fadeIn' style={{ background: theme?.buttonBackground, color: theme?.buttonColor }}>{button?.title}</button></a> : <Link to={`/app/${projectHash}/${button.url}`} ><button className='highlightButton shadow ' style={{ background: theme?.buttonBackground, color: theme?.buttonColor }}>{button?.title}</button></Link>
                            })}


                        </div>
                    </div>
                </div>
            </div>









        </Capa>
    </Container >

}

export default HomeApplication;